/**
 * «Куда оператора уже поставили в этот день» для долгого нажатия в «+» доски (16.10.2026, владелец). Игры считает
 * opStats.dayOf (с пересечениями); здесь — всё остальное, что доска знает о дне, из её ЖИВЫХ черновиков (как панель
 * «кто чем занят»): МК, учебная игра (играет), админ зала с часами, допработы. Контекст кладёт GamesFeed
 * (OoAssignScreen), чтобы не тянуть пять пропсов через карточку игры.
 */
import { createContext, useContext } from "react";
import type { BoardGame, HallTimesMap } from "../../hooks/useOoDay";
import type { HallAdminMap } from "./scoring";
import { ruBranch } from "./ruBranch";

export interface DayBusy {
  hall: HallAdminMap;
  hallTimes: HallTimesMap;
  mc: Record<string, { mcName: string; operatorIds: string[] }[]>;
  learn: Record<string, { id: string }[]>;
  extra: { operatorId: string; timeFrom: string; timeTo: string; description: string }[];
}

export const DayBusyCtx = createContext<DayBusy | null>(null);
export const useDayBusy = () => useContext(DayBusyCtx);

/** Строки «не игр» оператора за день: «МК Слайм · 14:00 Мотл», «играет ФНАФ 16:00», «◆ Админ зала 20Б 10:00–22:00», «доп 12:00–14:00 лампы». */
export function otherActs(opId: string, games: BoardGame[], d: DayBusy | null): string[] {
  if (!d) return [];
  const out: string[] = [];
  for (const g of [...games].sort((a, b) => (a.sortTime || a.time).localeCompare(b.sortTime || b.time))) {
    for (const a of d.mc[g.id] ?? []) if (a.operatorIds.includes(opId)) out.push(`${a.mcName.startsWith("МК") ? "" : "МК "}${a.mcName} · ${g.time} ${g.shortName}`);
    if ((d.learn[g.id] ?? []).some((p) => p.id === opId)) out.push(`играет ${g.shortName} ${g.time}`);
  }
  for (const [br, ids] of Object.entries(d.hall)) {
    if (!ids.includes(opId)) continue;
    const t = d.hallTimes[br];
    out.push(`◆ Админ зала ${ruBranch(br)}${t && (t.from || t.to) ? ` ${t.from ?? "…"}–${t.to ?? "…"}` : ""}`);
  }
  for (const e of [...d.extra].sort((a, b) => a.timeFrom.localeCompare(b.timeFrom))) {
    if (e.operatorId === opId) out.push(`доп ${e.timeFrom}–${e.timeTo}${e.description ? ` ${e.description}` : ""}`);
  }
  return out;
}
